// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

const getHeightVal = (aspectRatioObj, variation, heightVal, shouldRestrictMaxHeight) => {
  const { aspectRatioD, aspectRatioT, aspectRatioM } = !isEmpty(aspectRatioObj) && aspectRatioObj;
  const aspectMap = {
    MOBILE: aspectRatioM,
    TABLET: aspectRatioT,
    DESKTOP: aspectRatioD,
  };
  const aspect = aspectMap[variation];

  if (aspect) {
    return `height: 100%;`;
  }

  if (shouldRestrictMaxHeight) {
    return 'max-height: 500px;';
  }

  return `
    height: ${heightVal ? `${heightVal}px` : `100%`};
    max-height: ${heightVal ? `${heightVal}px` : `100%`};`;
};

export const MultiItemContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  position: relative;
  justify-content: center;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) => (props.isCombineImageDesign ? `` : `gap: 6px;`)}
    ${(props) => getHeightVal(props?.aspectRatioObj, 'MOBILE', props.tileHeightValue)}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    ${(props) => (props.isCombineImageDesign ? `` : `gap: 8px;`)}
    ${(props) => getHeightVal(props?.aspectRatioObj, 'TABLET', props.tileHeightValue)}
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    ${(props) => (props.isCombineImageDesign ? `` : `gap: 10px;`)}
    ${(props) =>
      getHeightVal(
        props?.aspectRatioObj,
        'DESKTOP',
        props.tileHeightValue,
        !(props.isFullRowView || props.shouldAllowMaxHeight)
      )}
  }
`;

export const CarouselContainer = styled.div`
  height: 100%;
  max-height: 100%;
  width: 100%;
  .images-scroll-wrapper {
    justify-content: ${(props) => (props.isAlignCenter ? `center` : `flex-start`)};
  }
`;

export const TopPromoContainer = styled.div`
  .images-scroll-wrapper {
    justify-content: ${(props) => (props.isAlignCenter ? `center` : `flex-start`)};
  }
`;
